import { clear_token, get_token, get_user_details , set_user_details } from "@/router";
import Swal from 'sweetalert2';

import NotificationDropdown from '@/components/Notifications/Notification.vue'
import HomeSidebar from '@/components/HomeSidebar/HomeSidebar.vue'
const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;


const domain = window.location.hostname;

export default {

  components: {
    NotificationDropdown,
    HomeSidebar
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isHomeFilterOrViewPortal() {
      return this.$route.name === 'home_filter' || this.$route.name === 'view_portal'|| this.$route.name === 'view_events';
    },
    firstNameInitial() {
      return this.userDetails.first_name.charAt(0);
    },
    visibleProfiles() {
      const profiles = this.base_profiles || [];
      const activePersonalProfile = profiles.find(p => p.profile_type === 'personal' && p.is_active);

      // Filter out duplicate personal profiles
      const uniqueProfiles = profiles.filter((profile, index, self) => {
        return (
          profile.profile_type !== 'personal' || // Keep non-personal profiles
          index === self.findIndex(p => p.profile_type === 'personal' && p.id === profile.id) // Keep only the first unique personal profile
        );
      });
    
      let result = uniqueProfiles.slice();

      result = result.filter((profile, index, self) => {
        return (
          profile.profile_type !== 'personal' || // Keep non-personal profiles
          (activePersonalProfile ? profile.id === activePersonalProfile.id : index === self.findIndex(p => p.profile_type === 'personal')) // Keep only the active personal profile or the first one
        );
      });

      return this.showAll ? result : result.slice(0, 3);
    },

    activeBaseProfile() {
      return this.base_profiles.find(profile => profile.is_active) || null;
    },

  },

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.loadGoogleMapEvent();
    this.user_id = this.get_user_id();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.get_all_profile();
    this.fetchProfiles();
    this.getActiveProfile();
    if(domain.includes('tdm')||domain.includes('chamber') || domain.includes('cbo')|| domain.includes('uat.workstreams') || domain.includes('staging')|| domain.includes('demo')) {
      this.visible_domain = true;
      
      $('#company_profile_modal').on('hidden.bs.modal', () => {
        this.update_first_time_login_status();
    });

    }

    if(domain.includes('workbook')) {
        this.workbook_domain = true;
      }
  },
  watch: {
    activeBaseProfile: {
      immediate: true,
      handler(newProfile) {
        this.$emit('active_profile', newProfile);
      }
    }
  },
  data() {
    return ({
      token_exists: false,
      user_id:null,
      visible_domain: false,
      user_details: {
        "user_role":'',
        "first_name":'',
        "last_name":'',
      },
      showIcons: false,
      showSearch: false,
      users: [], // Add profiles data property
      filteredProfiles: [], 
      searchQuery: '',
      isSidebarOpen: false,
      isEventSidebarOpen: false,
      company_name: '',
      type_of_organization: [],
      description: '',
      email: '',
      tell_number: '',
      location: '',
      organizationTypes: [],
      errors: {},
      isLoading: false,
      selected_type_of_organization: '',
      type_of_profile: [],
      selectedProfile: null,
      base_profiles: [],
      currentProfile: null,
      displayLetter: '',
      displayName: '',
      isBusinessProfile: false,
      companyData: null,
      showAll: false,
      profile_questions: [],
      workbook_domain: false,
      searchTimeout: null,
      is_edit_mode:false,
      base_profile_id: null,
      longitude:null,
      latitude:null,
    });
  },

  watch: {
    searchQuery() {
      this.filterProfiles();
    },
    activeBaseProfile: {
      immediate: true,
      handler(newProfile) {
        this.$emit('active_profile', newProfile);
      }
    }
  },
  methods: {
    open_edit_profile(business) {
    this.is_edit_mode = true;

    this.company_name = business.company_name;
    this.selected_type_of_organization = business.type_of_organization;
    this.description = business.description;
    this.email = business.email;
    this.tell_number = business.tell_number;
    this.location = business.location;
    this.base_profile_id= business.base_profile.id;
    $('#company_profile_modal').modal('show');
  },
  loadGoogleMapEvent() {
      if (!isNaN(this.latitude) && !isNaN(this.longitude)) {
        if (typeof window.google === 'undefined' || !window.google.maps) {

          const script = document.createElement('script');
          script.id = 'googleMapsScript';
          script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&callback=initMap&v=weekly`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);

          window.initMap = () => {
            this.initializeMap();
          };
        }
      }
    },
  update_company_profile(){
      Swal.fire({
          title: 'Updating...',
          text: 'Please wait while we update the company profile.',
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          }
      });

      this.isLoading = true;
      const businessProfile = this.type_of_profile.find(
          (profile) => profile.name.toUpperCase() === 'BUSINESS'
        );
      const formData = new FormData();
      formData.append('base_profile_id',this.base_profile_id);
      formData.append('company_name', this.company_name);
      formData.append('type_of_organization_id', this.selected_type_of_organization);
      this.description = this.$refs.quillCompanyEditorRef.getHTML()
      formData.append('description', this.description);
      formData.append('email', this.email);
      formData.append('tell_number', this.tell_number);
      formData.append('location', this.location);
      formData.append('profile_type_id', businessProfile.id);

      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_user_company/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
          },
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => {
              if (response.status === 'success') {
                this.$emit('profile_updated');

                  Swal.fire({
                      title: 'Success',
                      text: 'Company Profile Updated Successfully',
                      icon: 'success',
                      timer: 1000,
                      showConfirmButton: false,
                    }).then(() => {
                    $('#company_profile_modal').modal('hide');
                  });
              }
          },
          error: (error) => {
              console.error('Error:', error);
              Swal.fire({
                  title: 'Error',
                  text: 'An error occurred while updating the profile',
                  icon: 'error'
              });
          },
          complete: () => {
            this.clear_company_form()
              this.isLoading = false;
          },
      });
  },
    toggleSidebars() {
      if (this.isEventsPage) {
        this.toggleEventSidebar(); // Toggle the event sidebar
      } else {
        this.toggleHomeSidebar(); // Toggle the main sidebar
      }
    },
    toggleEventSidebar() {
      this.isEventSidebarOpen = !this.isEventSidebarOpen; // Toggle event sidebar
    },
    toggleHomeSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen; // Toggle main sidebar
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
  typeOfProfileId(name) {
    const profileType = this.type_of_profile.find(type => type.name.toLowerCase() === name.toLowerCase());
    return profileType ? profileType.id : null;
  },
    logout_user() {
      Swal.fire({
        title: 'Are you sure?',
        text: "Are you sure you want to logout?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, log out!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          clear_token();
          window.location.href = `/`;
        }
      });
    },
    toggleIcons() {
      this.showIcons = !this.showIcons;
    },

    get_all_profile() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: {user_id: this.user_id},
        success: (data) => {
          this.users = data.data.users_list;
          this.isLoading = false;
        }
      }
      )},
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    update_first_time_login_status() {
          $.ajax({
              type: 'POST',
              url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_first_time_login/`,
              contentType: 'application/json',
              headers: {
                  'Authorization': `Token ${get_token()}`,
              },
    
              success: (response) => {
                  var response_data = response.data;
                  set_user_details(response_data.user_details);
              }
          });
      },

    filterProfiles() {
      if (this.searchQuery) {
          this.isLoading = true;
          this.searchTimeout = setTimeout(() => {
              $.ajax({
                  url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/global_search_api/`,
                  type: 'POST',
                  headers: {
                      Authorization: `Token ${get_token()}`,
                      'Content-Type': 'application/json'
                  },
                  data: JSON.stringify({
                      query: this.searchQuery
                  }),
                  success: (response) => {
                      if (response.status === 'success') {
                          this.filteredProfiles = response.data;
                      }
                  },
                  complete: () => {
                      this.isLoading = false;
                  }
              });
          }, 1000);
      } else {
          this.filteredProfiles = [];
      }
  },


      getProfileLink(member) {
        // Check if the user is an admin
        if (member.role === 'admin') {
          // Return the link for admin profiles
          window.location.href = `/customer_profile?user_id=${member.id}`;
        } else if (member.role === 'user') {
          // Return the link for user profiles
          window.location.href = `/customer_profile?user_id=${member.id}`;
        } else {
          // Return a default profile link for other roles
          return `customer_profile`;
        }
      },

      view_profile(profile){
        const base = profile.base_profile.id;
        const type = profile.base_profile.profile_type;
        window.location.href = `/customer_profile?base=${base}&type=${type}`;
      },

      control_switching_profile(base_profile){

        if(domain.includes('cbo')){
          this.view_profile_nav(base_profile)
        }
        else{

          this.switchProfile(base_profile.id);
        }
      },

      view_profile_nav(base_profile){
        const base = base_profile.id;
        const type = base_profile.profile_type;
        window.location.href = `/customer_profile?base=${base}&type=${type}`;
      },
      view_portal(portal){
          if (portal?.portal_type?.name === 'incident') {
            this.$router.push({ name: 'view_incidents', params: { portal_id: portal.portal_id, portal_name:portal.name,} });
          } 
          else if(portal?.portal_type?.name === 'publishing'){
             this.$router.push({ name: 'publish_portal', params: { portal_id: portal.id, portal_name:portal.name,} });
          }
           else
            this.$router.push({ name: 'view_portal', params: { portal_id: portal.id, portal_name: portal.name, is_public:portal.is_public } });

      },

      view_tag(tag) {
  if (!tag) return;
this.searchQuery = '';

  this.$router.push({
    name: 'publish_portal',
    query: {
      tag_id: tag.id,
      tag_name: tag.name
    }
  });
},      initializeMap() {
      const defaultLat = parseFloat(this.latitude || 0);
      const defaultLng = parseFloat(this.longitude || 0);

      const mapOptions = {
        center: { lat: defaultLat, lng: defaultLng },
        zoom: 8,
        mapTypeId: 'roadmap',
      };

      const mapElement = document.querySelector('#mapSearchBox');
      if (mapElement) {
        const map = new window.google.maps.Map(mapElement, mapOptions);

        let marker = null;

        const input = document.getElementById('mapSearchBox');
        const searchBox = new window.google.maps.places.SearchBox(input);

        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        map.addListener('bounds_changed', () => {
          searchBox.setBounds(map.getBounds());
        });

        searchBox.addListener('places_changed', () => {
          const places = searchBox.getPlaces();

          if (!places || places.length === 0) {
            return;
          }

          const place = places[0];
          if (!place.geometry) {
            return;
          }

          // Update map center and zoom
          map.setCenter(place.geometry.location);
          map.setZoom(14);

          // Remove the existing marker, if any
          if (marker) {
            marker.setMap(null);
          }

          marker = new window.google.maps.Marker({
            position: place.geometry.location,
            map: map,
            title: place.name,
          });
          this.location = input.value;
          this.$emit('location_selected', input.value);
        });
      }
    },
    myLearningView() {
      const domain = window.location.hostname;
      let programe_name;
  
      if (domain.includes('workstreams') || domain.includes('demo')) {
          programe_name = 'workstreams learning';
      } else if (domain.includes('919')) {
          programe_name = '919 learning';
      } else if (domain.includes('chamber')) {
          programe_name = 'ICT Chamber learning';
      } else if (domain.includes('community')) {
          programe_name = 'Funax Community learning';
      }else if (domain.includes('workbook')) {
          programe_name = 'IC workbook learning';
      }
      else {
          programe_name = 'workstreams learning';
      }

  },
  
    open_maintenance() {
      if (!this.token_exists) {
          this.$router.push('/sign_in_finale');
          return;
      }
      this.$router.push('/incident_reporting');
    },
    fetchProfiles() {
      this.isLoading = true;

      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
              'Content-Type': 'application/json',
          },
          success: (response) => {
              if (response.status === 'success' && response.data.profiles) {
                  this.base_profiles = response.data.profiles;
                  this.$emit('active_profile', this.activeBaseProfile);
              }
          },
          complete: () => {
              this.isLoading = false;
          }
      });
  },
  clearPersonalData() {
      this.email = '';
      this.phone_number = '';
  },

  switchProfile(profileId,isLoading = true) {
    const selectedProfile = this.base_profiles.find(profile => profile.id === profileId);
  if (selectedProfile && selectedProfile.is_active) {
    window.location.href='/customer_profile'
    return;
  }
    this.isLoading = isLoading;
    if(this.isLoading){
    Swal.fire({
      title: 'Switching Profile...',
      text: 'Please wait while we switch your profile.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }
  
    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/switch_profile/`,
        method: 'POST',
        headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({ profile_id: profileId }),
          success: (response) => {
            if (response.status === 'success') {
              
              this.getActiveProfile(); 
              
              this.base_profiles.forEach(profile => {
                profile.is_active = profile.id === profileId;
              });
            }
          },
          error: (xhr, status, error) => {
            console.error("Error switching profile:", error);
          },
          complete: () => {
            // Delay the loading state completion by 3 seconds
            setTimeout(() => {
              this.completeProfileSwitch()
            }, 2000);
          },
    });
  },
  completeProfileSwitch() {
    this.isLoading = false;
      window.location.href = `/customer_profile`;
  },

  getActiveProfile() {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_profile/`,
      type: "GET",
      headers: {
        Authorization: `Token ${get_token()}`,
        "Content-Type": "application/json",
      },
      success: (response) => {
        if (response.status === "success") {
          this.currentProfile = response.data;

          const profileTypeName = response.data.profile_type?.toLowerCase();

          if (profileTypeName === 'business' && response.data.is_active) {
            this.clearPersonalData();
            this.isBusinessProfile = true;
          } else {
            this.isBusinessProfile = false;
            this.companyData = null;
          }

        }
      },
      error: (xhr, status, error) => {
        console.error("Error fetching active profile:", error);
      },
    });
  },

  toggleShowAll() {
    this.showAll = !this.showAll;
  },
  fetch_type_of_profile() {
    this.isLoading = true;

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
      type: 'GET',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json',
      },
      success: (response) => {
        if (response.status === 'success') {
          this.type_of_profile = response.data.type_of_profile_data;
          this.show_questions();
        }
      },
      complete: () => {

        this.isLoading = false;
      },
    });
  },


  show_questions() {
  const businessProfile = this.type_of_profile.find(
    (profile) => profile.name?.toLowerCase() === 'business'
  );

  if (!businessProfile || !businessProfile.id) {
    console.error("Business profile not found or invalid.");
    return;
  }

  const payload = {
    filter_values: {
      profile_type_id: businessProfile.id,
    },
  };

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
    type: "POST",
    headers: {
      Authorization: `Token ${get_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
    success: (response) => {
      this.profile_questions =response.data
      this.$emit('questions_fetched', this.profile_questions)
    },
    error: (xhr, status, err) => {
      console.error("Failed to fetch questions:", err);
    }
  });
},


update_answer(questionId, value) {
  const questionSection = this.profile_questions
    ?.flatMap(f => f?.form?.form_sections || [])
    ?.flatMap(s => s?.section?.question_sections || [])
    ?.find(qs => qs?.question?.id === questionId);

  if (questionSection) {
    questionSection.answer = value;
  }
},

      toggle_checkbox_answer(questionId, option, isChecked) {
        const questionSection = this.profile_questions
          ?.flatMap(f => f?.form?.form_sections || [])
          ?.flatMap(s => s?.section?.question_sections || [])
          ?.find(qs => qs?.question?.id === questionId);
      
        if (questionSection) {
          if (!Array.isArray(questionSection.answer)) {
            questionSection.answer = [];
          }
      
          if (isChecked) {
            if (!questionSection.answer.includes(option)) {
              questionSection.answer.push(option);
            }
          } else {
            questionSection.answer = questionSection.answer.filter(o => o !== option);
          }
        }
      },
      saveCompanyProfile() {

        Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we create the company profile.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.isLoading = true;

        const businessProfile = this.type_of_profile.find(
          (profile) => profile.name.toUpperCase() === 'BUSINESS'
        );

        const formData = new FormData();
        formData.append('company_name', this.company_name);
        formData.append('type_of_organization_id', this.selected_type_of_organization);
        this.description = this.$refs.quillCompanyEditorRef.getHTML()
        formData.append('description', this.description);
        formData.append('email', this.email);
        formData.append('tell_number', this.tell_number);
        formData.append('location', this.location);
        formData.append('profile_type_id', businessProfile.id);

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_company_profile/`,
            type: 'POST',
            headers: {
                Authorization: `Token ${get_token()}`,
            },
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                if (response.status === 'success') {

                    Swal.fire({
                        title: 'Success',
                        text: 'Company Profile Created Successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false,
                      }).then(() => {
                      this.update_first_time_login_status()
                      this.$emit('business_profile_created');
                      $('#company_profile_modal').modal('hide');
                    });
                }
            },
            error: (error) => {
                console.error('Error:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred while creating the profile',
                    icon: 'error'
                });
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    },
    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    clear_company_form() {
      this.is_edit_mode = false;
      this.company_name = '';
      this.selected_type_of_organization = '';
      this.description = '';
      this.email = '';
      this.tell_number = '';
      this.location = '';
      this.base_profile_id = null;
      this.errors = {};
      // Clear Quill editor if ref exists
      this.$nextTick(() => {
        if (this.$refs.quillCompanyEditorRef) {
          if (typeof this.$refs.quillCompanyEditorRef.setHTML === 'function') {
            this.$refs.quillCompanyEditorRef.setHTML('');
          } else if (this.$refs.quillCompanyEditorRef.quill) {
            this.$refs.quillCompanyEditorRef.quill.root.innerHTML = '';
          }
        }
      });
    },

  }
};